// services/cacheManager.js
import AsyncStorage from '@react-native-async-storage/async-storage';

class CacheManager {
  constructor() {
    this.cache = new Map();
    this.cacheExpiry = new Map();
    this.defaultTTL = 5 * 60 * 1000; // 5 minutes
  }

  async get(key) {
    // Check memory cache first
    if (this.cache.has(key)) {
      const expiry = this.cacheExpiry.get(key);
      if (expiry && Date.now() < expiry) {
        return this.cache.get(key);
      } else {
        this.cache.delete(key);
        this.cacheExpiry.delete(key);
      }
    }

    // Check persistent storage
    try {
      const cached = await AsyncStorage.getItem(`cache_${key}`);
      if (cached) {
        const { data, expiry } = JSON.parse(cached);
        if (Date.now() < expiry) {
          this.cache.set(key, data);
          this.cacheExpiry.set(key, expiry);
          return data;
        } else {
          await AsyncStorage.removeItem(`cache_${key}`);
        }
      }
    } catch (error) {
      console.error('Cache retrieval error:', error);
    }

    return null;
  }

  async set(key, data, ttl = this.defaultTTL) {
    const expiry = Date.now() + ttl;
    
    // Set in memory cache
    this.cache.set(key, data);
    this.cacheExpiry.set(key, expiry);

    // Set in persistent storage
    try {
      await AsyncStorage.setItem(`cache_${key}`, JSON.stringify({ data, expiry }));
    } catch (error) {
      console.error('Cache storage error:', error);
    }
  }

  async invalidate(key) {
    this.cache.delete(key);
    this.cacheExpiry.delete(key);
    try {
      await AsyncStorage.removeItem(`cache_${key}`);
    } catch (error) {
      console.error('Cache invalidation error:', error);
    }
  }

  async clear() {
    this.cache.clear();
    this.cacheExpiry.clear();
    try {
      const keys = await AsyncStorage.getAllKeys();
      const cacheKeys = keys.filter(key => key.startsWith('cache_'));
      await AsyncStorage.multiRemove(cacheKeys);
    } catch (error) {
      console.error('Cache clear error:', error);
    }
  }
}

export default new CacheManager();